const data = {
  positionApplied: [
    "Software Engineer",
    "Team Lead Software Engineer",
    "Project Management Officer",
    "Admin Associate",
    "HR Associate",
    "Software Quality Assurance",
  ],
  civilStatus: ["Single", "Married", "Widowed", "Legally Separated/Divorced"],
  degrees: [
    "High School Level",
    "High School Graduate",
    "Vocational School Graduate",
    "College Level",
    "College Graduate",
    "Some Graduate School",
    "Completed Graduate School",
  ],
  maximumImageSize: 2097152,
  maximumResumeFileSize: 900000,
  maximumDocumentFileSize: 900000,
  skills: {
    "Software Engineer": [
      "Python",
      "ReactJS",
      "Javascript",
      "PHP",
      "Java",
      "AWS",
      "HTML",
      "CSS",
      "Git/Gitflow",
      "Bitbucket",
    ],
    "Team Lead Software Engineer": [
      "Python",
      "ReactJS",
      "Javascript",
      "PHP",
      "Java",
      "AWS",
      "HTML",
      "CSS",
      "Git/Gitflow",
      "Bitbucket",
    ],
    "Project Management Officer": [
      "Jira",
      "Microsoft Office",
      "GSuite Tools",
      "website app development",
      "mobile app development",
      "Scrum Agile",
      "Sprint",
    ],
    "Admin Associate": [
      "Google Workspace Applications",
      "MS Office Applications",
      "Accounting Procedures",
      "Technical Accounting Procedures",
      "Office Management",
      "Basic Accounting Procedures",
      "Liaising and Negotiation Skills",
    ],
    "HR Associate": [
      "Job Analysis",
      "Sourcing and Manpower Planning",
      "Talent Acquisition and Hiring",
      "Employee Onboarding",
      "Employee Engagement",
      "Digital Recruitment (PR)",
      "Learning and Development",
      "Total Rewards",
      "Employee Relations and Discipline",
      "Culture Building and Management",
    ],
    "Software Quality Assurance": [
      "Manual Testing",
      "Git",
      "Gitflow",
      "JIRA",
      "Test Automation",
      "Functional Testing",
      "Performance Testing",
      "Testing Principles",
      "Test Case Creation",
      "Bug Identification, Documentation and Tracking",
    ],
  },
  technicalExamStatus: [
    "Pending",
    "Read",
    "Shortlisted",
    "Technical Exam",
    "Initial Interview",
    "Psychological Exam",
    "Final Interview",
    "Job Offer",
    "Failed",
  ],
  applicationStatus: [
    "Confirmed",
    "Declined",
    "No Show",
    "No Response",
    "Blacklisted",
    "Reschedule",
    "Failed",
  ],
  jobOfferStatuses: [
    "Confirmed",
    "Declined",
    "No Show",
    "No Response",
    "Accepted",
    "Reschedule",
  ],
  menuItemStatus: [
    "Unread",
    "Read",
    "Shortlisted",
    "Technical Exam",
    "Initial Interview",
    "Psychological Exam",
    "Final Interview",
    "Job Offer",
    "Failed",
  ],
  failedReasons: [
    "Lacking experience",
    "Missing competencies or skills",
    "Incompatible experience",
    "Salary expectation beyond budget",
    "Residence is too far",
  ],
  defaultSelectedTab: "/recruit/new-applicants",
  failedStatuses: ["No Show", "No Response", "Blacklisted"],
  userAccessType: ["Interviewer", "Recruiter"],
  commonNetworkError:
    "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
  toastNetworkErrorMessage:
    "You are offline. Please check your internet connection and try again.",
  noInterviewerRoutes: [
    "/recruit/search-applicants",
    "/recruit/new-applicants",
    "/recruit/shortlisted",
    "/recruit/technical-exam",
    "/recruit/psychological-exam",
    "/recruit/job-offer",
    "/recruit/failed",
    "/admin/users",
    "/admin/positions",
  ],
  loginErrorMessages: {
    incorrectPassword:
      "The password is invalid or the user does not have a password.",
    suspendedAccount: "The user account has been disabled by an administrator.",
    frequentFailedLogins:
      "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
    invalidEmailAndPassword: "There is no user record corresponding to this identifier. The user may have been deleted.",
  },
  defaultInterviewers: [
    { name: "Enzo Taniola", email: "enzo@vananaz.com" },
    { name: "Mary Louise Opura", email: "louise@vananaz.com" },
  ],
  applicantErrorMessages: {
    fileNameAlreadyExists: "File name already exists.",
  }
};
export default data;
